const messages = {
	en: {
		translations: {
			signup: {
				title: "Sign up",
				toasts: {
					success: "User created successfully! Please login!",
					fail: "Error creating user. Check the reported data.",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Register",
					login: "Already have an account? Log in!",
				},
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Enter",
					register: "Don't have an account? Register!",
				},
			},
			auth: {
				toasts: {
					success: "Login successfully!",
				},
			},
			dashboard: {
				charts: {
					perDay: {
						title: "Tickets today: ",
					},
				},
			},
			connections: {
				title: "Connections",
				toasts: {
					deleted: "WhatsApp connection deleted sucessfully!",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? It cannot be reverted.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Are you sure? You'll need to read QR Code again.",
				},
				buttons: {
					add: "Add WhatsApp",
					disconnect: "Disconnect",
					tryAgain: "Try Again",
					qrcode: "QR CODE",
					newQr: "New QR CODE",
					connecting: "Connectiing",
					recoverCloud: "Recover",
				},
				sessionInvalidated: {
					cloud:
						"The Cloud connection with Meta expired or was revoked. Go to Connections and click Recover to re-authorize with Meta.",
					baileys:
						"Your WhatsApp session was closed from the phone. To keep sending messages, link the device again by scanning the QR code.",
				},
				toolTips: {
					cloudApi: {
						disconnected: {
							title: "WhatsApp Cloud disconnected",
							content: "Re-authorize with Meta (Embedded Signup) to restore your WABA token. No QR code is used.",
						},
						pending: {
							title: "Cloud setup pending",
							content: "Complete Meta Embedded Signup to link your WhatsApp Business API number and token.",
						},
						connected: {
							title: "WhatsApp Cloud connected",
							content: "Cloud line is active via Meta API (valid WABA and token).",
						},
						invalid: {
							title: "Invalid Cloud session",
							content: "The token expired or was revoked. Use Recover to reconnect with Meta.",
						},
						quality: {
							green: {
								title: "Phone quality: good",
								content: "Meta reports GREEN quality for this Cloud line.",
							},
							yellow: {
								title: "Phone quality: attention",
								content:
									"Meta reports YELLOW quality. Review templates, blocks, and send volume in Meta Business Suite before the line is limited.",
							},
							red: {
								title: "Phone quality: at risk",
								content:
									"Meta reports RED quality. This line may stop sending messages. Check the number status in Meta Business Suite and fix the issues Meta flagged.",
							},
							limit: "Messaging limit: {{limit}}",
							openMeta: "Open Meta Business Suite",
						},
					},
					disconnected: {
						title: "Failed to start WhatsApp session",
						content:
							"Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
					},
					qrcode: {
						title: "Waiting for QR Code read",
						content:
							"Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
					},
					connected: {
						title: "Connection established",
					},
					timeout: {
						title: "Connection with cell phone has been lost",
						content:
							"Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
					},
				},
				table: {
					name: "Name",
					status: "Status",
					lastUpdate: "Last Update",
					default: "Default",
					actions: "Actions",
					session: "Session",
				},
			},
			whatsappModal: {
				title: {
					add: "Add WhatsApp",
					edit: "Edit WhatsApp",
				},
				form: {
					name: "Name",
					default: "Default",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "WhatsApp saved successfully.",
			},
			qrCode: {
				message: "Read QrCode to start the session",
			},
			contacts: {
				title: "Contacts",
				toasts: {
					deleted: "Contact deleted sucessfully!",
				},
				searchPlaceholder: "Search ...",
				confirmationModal: {
					deleteTitle: "Delete",
					importTitlte: "Import contacts",
					deleteMessage:
						"Are you sure you want to delete this contact? All related tickets will be lost.",
					importMessage: "Do you want to import all contacts from the phone?",
				},
				buttons: {
					import: "Import Contacts",
					add: "Add Contact",
				},
				table: {
					name: "Name",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Actions",
				},
			},
			contactModal: {
				title: {
					add: "Add contact",
					edit: "Edit contact",
				},
				form: {
					mainInfo: "Contact details",
					extraInfo: "Additional information",
					name: "Name",
					number: "Whatsapp number",
					email: "Email",
					extraName: "Field name",
					extraValue: "Value",
				},
				buttons: {
					addExtraInfo: "Add information",
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Contact saved successfully.",
			},
			queueModal: {
				title: {
					add: "Add queue",
					edit: "Edit queue",
				},
				form: {
					name: "Name",
					color: "Color",
					greetingMessage: "Greeting Message",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
			},
			userModal: {
				title: {
					add: "Add user",
					edit: "Edit user",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
					profile: "Profile",
					language: "Language",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "User saved successfully.",
			},
			chat: {
				noTicketMessage: "Select a ticket to start chatting.",
			},
			ticketsManager: {
				buttons: {
					newTicket: "New",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Queues",
			},
			tickets: {
				toasts: {
					deleted: "The ticket you were on has been deleted.",
				},
				notification: {
					message: "Message from",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Resolved" },
					search: { title: "Search" },
				},
				search: {
					placeholder: "Search tickets and messages.",
				},
				buttons: {
					showAll: "All",
				},
			},
			transferTicketModal: {
				title: "Transfer Ticket",
				fieldLabel: "Type to search for users",
				noOptions: "No user found with this name",
				buttons: {
					ok: "Transfer",
					cancel: "Cancel",
				},
			},
			ticketsList: {
				pendingHeader: "Queue",
				assignedHeader: "Working on",
				noTicketsTitle: "Nothing here!",
				noTicketsMessage: "No tickets found with this status or search term.",
				buttons: {
					accept: "Accept",
				},
			},
			newTicketModal: {
				title: "Create Ticket",
				fieldLabel: "Type to search for a contact",
				add: "Add",
				buttons: {
					ok: "Save",
					cancel: "Cancel",
				},
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Connections",
					tickets: "Tickets",
					todolist: "to-Do List",
					contacts: "Contacts",
					whatsappTemplates: "WhatsApp templates",
					queues: "Queues",
					administration: "Administration",
					users: "Users",
					settings: "Settings",
				},
				appBar: {
					user: {
						profile: "Profile",
						logout: "Logout",
					},
				},
			},
			notifications: {
				noTickets: "No notifications.",
			},
			whatsappTemplates: {
				title: "WhatsApp Cloud templates",
				emptyLines: "Connect a WhatsApp Cloud line to manage templates.",
				table: {
					name: "Name",
					language: "Language",
					category: "Category",
					status: "Status",
					preview: "Preview",
				},
				categories: {
					UTILITY: "Utility",
					MARKETING: "Marketing",
					AUTHENTICATION: "Authentication",
				},
				templateLanguages: {
					pt_BR: "Português (BR)",
					en_US: "English (US)",
					es_MX: "Español (México)",
					legacy: "{{code}} (saved language)",
				},
				status: {
					DRAFT: "Draft",
					PENDING: "Pending",
					APPROVED: "Approved",
					REJECTED: "Rejected",
					PAUSED: "Paused",
					DISABLED: "Disabled",
				},
				buttons: {
					add: "New template",
					sync: "Sync from Meta",
					save: "Save",
					cancel: "Cancel",
					submit: "Submit to Meta",
					preview: "Preview template",
				},
				preview: {
					close: "Close",
					readOnlyHint:
						"Read-only preview. Variables are shown as placeholders.",
				},
				dialog: {
					addTitle: "Create template",
					editTitle: "Edit template",
					subtitle: "Create a template and submit it for Meta approval",
					line: "Cloud connection",
					name: "Name",
					nameHint: "lowercase, numbers, and _",
					nameInvalid: "Must start with a lowercase letter and use only a-z, 0-9, and _",
					language: "Language",
					category: "Category",
					headerOptional: "Header — optional",
					headerFormat: "Header type",
					headerFormats: {
						NONE: "No header",
						TEXT: "Text",
						IMAGE: "Image",
						VIDEO: "Video",
						DOCUMENT: "Document",
					},
					headerText: "Header text",
					headerTextHint:
						"Fixed text only (max 60). Meta does not allow variables in the header.",
					headerMediaUrl: "Sample URL (HTTPS)",
					headerMediaAttach: "Attach file",
					headerMediaUploading: "Uploading…",
					headerMediaEmpty: "No sample file",
					headerMediaUrlHint:
						"Meta requires a sample file to approve image, video, or document headers.",
					body: "Body",
					footerOptional: "Footer — optional",
					footerText: "Footer text",
					buttonsOptional: "Buttons — optional ({{count}}/{{max}})",
					quickReplyButton: "Quick reply",
					addQuickReply: "Quick reply",
					addUrlButton: "URL button",
					addPhoneButton: "Call button",
					urlButtonText: "Button text",
					urlButtonUrl: "Button URL",
					urlButtonUrlHint: "You can use {{1}} at the end for a dynamic suffix.",
					phoneButtonText: "Button text",
					phoneButtonNumber: "Phone (E.164)",
					phoneButtonNumberHint: "Example: +14155552671",
					quickReplyButtonsHint:
						"Up to 3 quick replies. They cannot be mixed with URL or call buttons.",
					ctaButtonsHint:
						"Up to 2 call-to-action buttons (URL or call). They cannot be mixed with quick replies.",
					carouselComingSoon: "Carousel templates will be available in a future release.",
					addVariable: "+ Add variable",
					variableExamplesTitle: "Variable examples",
					variableExamplesHint:
						"Meta requires one sample value per variable. Used in preview and when submitting for review.",
					variableExamplePlaceholder: "Example for {{index}}",
					addButton: "Add button",
					authInfo:
						"Authentication templates are generated automatically (OTP code + security recommendation). Define only name, language, and connection.",
					authTitle: "OTP template",
					authSubtitle: "Meta generates the verification message. Configure only name, language, and connection.",
					authSecurityRecommendation: "Include security recommendation",
					authCodeExpiration: "Code expiration",
					authCodeExpirationOption: "{{minutes}} minutes",
					authCodeExpirationHint: "Meta shows this time in the message footer (1–90 min).",
					authPreviewNote: "Approximate preview. Meta localizes the final text by language.",
					authPreview: "Meta will generate the OTP message automatically.",
					authCodeLabel: "OTP code",
				},
				picker: {
					title: "Send template message",
					subtitle: "Choose a template and fill in the variables",
					selectLabel: "Select a template",
					variableLabel: "Variable {{index}}",
					previewTitle: "Preview",
					previewEmpty: "Select a template to see the preview.",
					variablesHint:
						"Variables appear as placeholders; the real value is substituted when the message is sent.",
					businessName: "Venttify",
					today: "Today",
					send: "Send",
					empty: "No approved templates for this line.",
					manageLink: "Manage templates",
					sent: "Template sent.",
					noLine: "This ticket has no Cloud line.",
					paymentRequiredWarning:
						"Sending is blocked because there is no active payment method in Meta.",
					paymentRequiredAction: "See how to fix it",
				},
				delete: {
					title: "Delete template",
					body: "Delete this template? If it exists in Meta, deletion will be requested there too.",
				},
				toasts: {
					created: "Template saved as draft.",
					updated: "Template updated.",
					submitted: "Template submitted to Meta for review.",
					deleted: "Template deleted.",
					synced: "Synced {{count}} template(s) from Meta.",
				},
				validation: {
					submitBlocked:
						"Fix these issues before submitting the template to Meta:",
					title: "Meta requirements",
					template_variable_at_end:
						"Variables cannot be at the end of the header, body, or URL. Add text after {{n}}.",
					template_variable_at_start:
						"Variables cannot be at the start of the header, body, or URL.",
					template_header_too_many_variables:
						"Text headers only support one variable.",
					template_header_variables_not_allowed:
						"The header cannot contain variables. Use fixed text only or remove {{n}} from the header.",
					template_variable_examples_missing:
						"Provide an example for each variable before saving or submitting to Meta.",
					template_variables_not_sequential:
						"Variables must be consecutive: {{1}}, {{2}}, {{3}}… with no gaps.",
					language_normalized_es:
						"Language «es» will be sent to Meta as es_MX.",
					language_normalized_en:
						"Language «en» will be sent to Meta as en_US.",
					language_normalized_pt:
						"Language «pt» will be sent to Meta as pt_BR.",
					template_media_sample_required:
						"Attach a sample file for the multimedia header.",
					template_media_sample_invalid_type:
						"Invalid file type for this header.",
				},
				categoryHints: {
					title: "Category alignment",
					submitWarningShort:
						"Meta may reclassify this template's category.",
					utility_likely_reclassified:
						"This content may be approved as Marketing even though you selected Utility.",
					utility_promotional_language:
						"Promotional language detected (offer, discount, exclusive…). Meta often moves this to Marketing.",
					utility_sales_cta:
						"Sales call-to-action detected (buy now, visit our site…).",
					utility_generic_greeting:
						"The greeting looks generic with no order, appointment, or account context.",
					utility_missing_transaction_context:
						"No clear reference to order, payment, appointment, booking, or account.",
					utility_enthusiastic_tone:
						"The tone looks promotional or enthusiastic; Meta is strict with Utility templates.",
					marketing_looks_utility:
						"The text looks transactional. You might save cost by using the Utility category.",
				},
			},
			queues: {
				title: "Queues",
				table: {
					name: "Name",
					color: "Color",
					greeting: "Greeting message",
					actions: "Actions",
				},
				buttons: {
					add: "Add queue",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
				},
			},
			queueSelect: {
				inputLabel: "Queues",
			},
			users: {
				title: "Users",
				table: {
					name: "Name",
					email: "Email",
					profile: "Profile",
					actions: "Actions",
				},
				buttons: {
					add: "Add user",
				},
				toasts: {
					deleted: "User deleted sucessfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"All user data will be lost. Users' open tickets will be moved to queue.",
				},
			},
			settings: {
				success: "Settings saved successfully.",
				title: "Settings",
				settings: {
					userCreation: {
						name: "User creation",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
				},
			},
			messagesList: {
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Return",
						resolve: "Resolve",
						reopen: "Reopen",
						accept: "Accept",
					},
				},
			},
			messagesInput: {
				placeholderOpen: "Type a message",
				placeholderClosed: "Reopen or accept this ticket to send a message.",
				signMessage: "Sign",
			},
			contactDrawer: {
				header: "Contact details",
				channel: "Channel",
				buttons: {
					edit: "Edit contact",
				},
				channels: {
					whatsapp: "WhatsApp",
					whatsapp_api: "WhatsApp Cloud",
					webchat: "Webchat",
				},
				extraInfo: "Other information",
			},
			ticketOptionsMenu: {
				delete: "Delete",
				transfer: "Transfer",
				markAsUnread: "Mark as unread",
				confirmationModal: {
					title: "Delete ticket #",
					titleFrom: "from contact ",
					message: "Attention! All ticket's related messages will be lost.",
				},
				buttons: {
					delete: "Delete",
					cancel: "Cancel",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancel",
				},
			},
			messageOptionsMenu: {
				delete: "Delete",
				reply: "Reply",
				confirmationModal: {
					title: "Delete message?",
					message: "This action cannot be reverted.",
				},
			},
			backendErrors: {
				ERR_NO_OTHER_WHATSAPP:
					"There must be at lest one default WhatsApp connection.",
				ERR_NO_DEF_WAPP_FOUND:
					"No default WhatsApp found. Check connections page.",
				ERR_WAPP_NOT_INITIALIZED:
					"This WhatsApp session is not initialized. Check connections page.",
				ERR_WAPP_CHECK_CONTACT:
					"Could not check WhatsApp contact. Check connections page.",
				ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Could not download media from WhatsApp. Check connections page.",
				ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
				ERR_SENDING_WAPP_MSG:
					"Error sending WhatsApp message. Check connections page.",
				ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
				ERR_CLOUD_MESSAGE_ACTION_NOT_SUPPORTED:
					"WhatsApp Cloud API does not support editing or deleting messages.",
				ERR_OTHER_OPEN_TICKET:
					"There's already an open ticket for this contact.",
				ERR_SESSION_EXPIRED: "Session expired. Please login.",
				ERR_USER_CREATION_DISABLED:
					"User creation was disabled by administrator.",
				ERR_NO_PERMISSION: "You don't have permission to access this resource.",
				ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
				ERR_NO_SETTING_FOUND: "No setting found with this ID.",
				ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
				ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
				ERR_NO_USER_FOUND: "No user found with this ID.",
				ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
				ERR_CREATING_MESSAGE: "Error while creating message on database.",
				ERR_CREATING_TICKET: "Error while creating ticket on database.",
				ERR_FETCH_WAPP_MSG:
					"Error fetching the message in WhtasApp, maybe it is too old.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"This color is already in use, pick another one.",
				ERR_WAPP_GREETING_REQUIRED:
					"Greeting message is required if there is more than one queue.",
				outside_window:
					"The WhatsApp Cloud 24-hour service window closed. Use an approved template to resume the conversation.",
				invalid_message_tag:
					"The Messenger message tag is invalid or not allowed for this send.",
				messenger_tag_not_allowed_in_window:
					"Messenger tags cannot be used while the 24-hour window is open. Send a normal message instead.",
				payment_method_required:
					"Send blocked: no payment method in Meta. Click for setup instructions.",
				not_on_whatsapp:
					"This number is not on WhatsApp or cannot receive messages.",
				rate_limited:
					"Meta rate-limited sending. Try again in a few seconds.",
				whatsapp_messaging_scope_required:
					"Meta did not grant message sending. Reconnect the line and accept all WhatsApp permissions.",
				whatsapp_discovery_scope_required:
					"Meta permissions to locate your WhatsApp account are missing. Reconnect and accept business_management and whatsapp_business_management.",
				whatsapp_onboarding_scope_required:
					"Meta permissions to register the Cloud line are missing. Reconnect and accept whatsapp_business_management and whatsapp_business_messaging.",
				whatsapp_cloud_discovery_failed:
					"Could not locate your WhatsApp account in Meta. Check permissions or reconnect the line.",
				no_whatsapp_business_phone:
					"No WhatsApp Business phone number was found for your Meta account.",
				embedded_signup_assets_missing:
					"Meta finished signup but did not return the WhatsApp account. Ensure your domain is listed in the Meta app allowed domains and reconnect.",
				whatsapp_cloud_register_failed:
					"Could not register the number on WhatsApp Cloud API. Check Meta permissions or reconnect.",
				whatsapp_cloud_register_pin_invalid:
					"The WhatsApp Cloud PIN must be 6 digits.",
				whatsapp_number_in_use_on_device:
					"This number is still active on WhatsApp Business or personal on a phone. Unlink it, wait 3 minutes, and reconnect.",
				waba_subscription_failed:
					"Could not subscribe the Meta app to the WABA. Check whatsapp_business_management permissions.",
				facebook_code_exchange_failed:
					"Could not exchange the Meta authorization code. For Embedded Signup, ensure Front and Biz use the same Meta app.",
				facebook_app_not_configured:
					"WhatsApp Cloud is not configured on the server (FACEBOOK_APP_ID / META_APP_SECRET).",
				facebook_token_invalid:
					"The Meta token expired or is invalid. Reconnect the line in Connections.",
				facebook_token_inspection_failed:
					"Could not verify the Meta token. Try again or contact support.",
				session_invalid:
					"The Cloud connection expired. Reconnect the line in Connections.",
				graph_unavailable:
					"Meta did not respond. Try again later.",
				line_not_ready:
					"The Cloud line is not ready. Check Connections.",
				backpressure:
					"Too many simultaneous sends. Wait and try again.",
				invalid_to:
					"Invalid destination number.",
				media_not_found:
					"The attachment file was not found.",
				storage_unavailable:
					"Storage is unavailable. Contact support.",
				schedule_window_closed:
					"Cannot schedule text: the 24-hour window does not cover the chosen time. Adjust the date or wait for a customer message.",
				graph_rejected:
					"Meta rejected the template. Check the text, variables, and language.",
				template_variable_at_end:
					"Variables cannot be at the end of the header or body. Add text after {{n}}.",
				template_variable_at_start:
					"Variables cannot be at the start of the header or body.",
				template_header_too_many_variables:
					"Text headers only support one variable.",
				meta_template_submit_failed:
					"Could not submit the template to Meta. Review the content and try again.",
				template_media_sample_required:
					"Attach a sample file for the multimedia header.",
				template_media_sample_invalid:
					"Could not process the header sample file.",
				facebook_app_id_required:
					"FACEBOOK_APP_ID is not configured on the Meta service.",
			},
			ticketComposer: {
				cloudWindow: {
					bannerTitle: "24-hour window closed",
					bannerTitleOpen: "You can send free-form messages",
					bannerBodyNoInbound:
						"Under WhatsApp Cloud policy, you cannot start the chat with text or files. Send an approved template to reach the customer.",
					bannerBodyExpired:
						"Under WhatsApp Cloud policy, free-form chat lasts 24 hours from the customer's last message. That period ended{{expiry}}. Send an approved template to resume the conversation.",
					bannerBodyOpen:
						"Under WhatsApp Cloud policy, you can send free messages and files until {{expiry}}. After that, only approved templates are allowed.",
					templateButton: "Send template",
					templateMenuItem: "Message template",
					templateComingSoon:
						"The template catalog is coming soon. For now, send templates via integrations only.",
				},
				messengerWindow: {
					bannerTitle: "24-hour window closed",
					bannerBodyNoInbound:
						"Under Messenger policy, you cannot start the chat with free-form text. Use an allowed Meta message tag to reach the customer.",
					bannerBodyExpired:
						"Under Messenger policy, free-form chat lasts 24 hours from the customer's last message. That period ended{{expiry}}. Use a message tag to resume the conversation.",
					bannerBodyOpen:
						"Under Messenger policy, you can send free messages and files until {{expiry}}.",
					splitMediaTextHint:
						"Messenger sends the file and text as two separate messages.",
					splitMediaTextHintPending:
						"Type a message below to send it with the file (as a separate message).",
				},
				instagramWindow: {
					bannerTitle: "24-hour window closed",
					bannerBodyNoInbound:
						"Under Instagram policy, you cannot start the chat with free-form text. Use an allowed Meta message tag to reach the customer.",
					bannerBodyExpired:
						"Under Instagram policy, free-form chat lasts 24 hours from the customer's last message. That period ended{{expiry}}. Use a message tag to resume the conversation.",
					bannerBodyOpen:
						"Under Instagram policy, you can send free messages and files until {{expiry}}.",
					splitMediaTextHint:
						"Instagram sends the file and text as two separate messages.",
					splitMediaTextHintPending:
						"Type a message below to send it with the file (as a separate message).",
				},
			},
			messengerTags: {
				modal: {
					openButton: "Send with tag",
					title: "Send with Messenger tag",
					subtitle:
						"Outside the 24-hour window you can only send with the HUMAN_AGENT tag (requires Meta-approved permission).",
					policyHint:
						"Meta no longer allows post-purchase, event, or account tags; use HUMAN_AGENT for agent replies. Content must comply with Meta policy.",
					policyHintInstagram:
						"Outside the 24-hour window only the HUMAN_AGENT tag is available (requires Meta-approved permission). Content must comply with Meta policy.",
					tagLabel: "Message tag",
					messageLabel: "Message",
					messagePlaceholder: "Type your message…",
					cancel: "Cancel",
					send: "Send",
				},
				validation: {
					bodyRequired: "Enter a message before sending.",
				},
				tags: {
					HUMAN_AGENT: {
						label: "Human agent (HUMAN_AGENT)",
						hint: "Human agent reply when the customer wrote outside the window (up to 7 days). Requires Human Agent permission on your Meta app.",
					},
				},
			},
			cloudPaymentRequired: {
				title: "Could not send the WhatsApp message",
				intro:
					"Your WhatsApp Business API account does not have a configured or active payment method, so Meta has temporarily blocked message sending.",
				stepsTitle: "To fix this:",
				step1: "Open Meta Business Manager.",
				step2: "Go to the billing section.",
				step3: "Add or update a valid payment method.",
				step4: "Make sure there are no pending invoices or failed payments.",
				footer: "Once billing is set up, try sending the message again.",
				billingLink: "Open Meta billing",
				close: "Got it",
			},
		},
	},
};

export { messages };
